import { t } from 'i18next'

export interface ItemProps {
    title?: string,
    subtitle?: string
}

function NotFound({title = t('not_found.title'), subtitle = t('not_found.subtitle')}: ItemProps) {
    return (
        <div className='not_found'>
			<svg className='not_found-icon' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
				<path d='M5.56811 3L10 3.00001C10.5523 3.00001 11 3.44772 11 4.00001V10C11 10.5523 10.5523 11 10 11H4.00001C3.44772 11 3.00001 10.5523 3.00001 10L3 5.56811C2.99997 5.31573 2.99994 5.06993 3.01695 4.86178C3.03563 4.63318 3.07969 4.36345 3.21799 4.09202C3.40974 3.7157 3.7157 3.40974 4.09202 3.21799C4.36345 3.07969 4.63318 3.03563 4.86178 3.01695C5.06993 2.99994 5.31573 2.99997 5.56811 3Z'></path>
				<path d='M19.1382 3.01695C19.3668 3.03563 19.6366 3.07969 19.908 3.21799C20.2843 3.40974 20.5903 3.7157 20.782 4.09202C20.9203 4.36345 20.9644 4.63318 20.9831 4.86178C21.0001 5.0699 21 5.31564 21 5.56798L21 10C21 10.5523 20.5523 11 20 11H14C13.4477 11 13 10.5523 13 10V4.00001C13 3.44772 13.4477 3.00001 14 3.00001L18.4319 3C18.6843 2.99997 18.9301 2.99994 19.1382 3.01695Z'></path>
				<path d='M3.00001 14C3.00001 13.4477 3.44772 13 4.00001 13H10C10.5523 13 11 13.4477 11 14V20C11 20.5523 10.5523 21 10 21L5.56811 21C5.31575 21 5.06992 21.0001 4.86178 20.9831C4.63318 20.9644 4.36345 20.9203 4.09202 20.782C3.7157 20.5903 3.40974 20.2843 3.21799 19.908C3.07969 19.6366 3.03563 19.3668 3.01695 19.1382C2.99994 18.9301 2.99997 18.6843 3 18.4319L3.00001 14Z'></path>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M19.8284 14.1722C18.2663 12.6101 15.7337 12.6101 14.1716 14.1722C12.6095 15.7343 12.6095 18.2669 14.1716 19.829C15.4895 21.147 17.4983 21.353 19.0322 20.447L20.2929 21.7077C20.6834 22.0982 21.3166 22.0982 21.7071 21.7077C22.0976 21.3172 22.0976 20.684 21.7071 20.2935L20.4464 19.0328C21.3524 17.4989 21.1464 15.4901 19.8284 14.1722ZM15.5858 15.5864C16.3668 14.8053 17.6332 14.8053 18.4142 15.5864C19.1953 16.3674 19.1953 17.6338 18.4142 18.4148C17.6332 19.1959 16.3668 19.1959 15.5858 18.4148C14.8047 17.6338 14.8047 16.3674 15.5858 15.5864Z'
				></path>
			</svg>
			<div className='text-center'>
				<span>{title}</span>
				<span>{subtitle}</span>
			</div>
		</div>
    );
}

export default NotFound;